import React from "react";
import { BookIcon, MapPinIcon, ImageIcon, BoxIcon } from "lucide-react";
import { includedFeatures } from "../data/content";
const ICONS = [BookIcon, MapPinIcon, BoxIcon, ImageIcon];
export function IncludedSection() {
  return <section className="w-full bg-night-deep px-5 pb-12 pt-12" aria-labelledby="incluye-titulo" data-id="element-104" data-mp="37gfvxfw0ruxq">
      <div className="mx-auto max-w-3xl" data-id="element-105" data-mp="3cf0oct515abm">
        <h2 id="incluye-titulo" className="text-center font-display text-2xl font-bold leading-snug text-cream md:text-[2rem]" data-id="element-106" data-mp="3cg27zm04354y">
          Todo lo que necesitas para entender <span className="text-gold" data-id="element-107" data-mp="7zhoqm0149o7">por fin</span> el mundo de la Biblia — en una
          sola guía visual
        </h2>

        <div className="mt-12 rounded-2xl border border-night-line/70 bg-night/60 p-5 md:p-7" data-id="element-108" data-mp="3qbw6rc768e4c">
          <ul className="grid gap-5 sm:grid-cols-2" data-id="element-109" data-mp="3vaz224xcn5z4">
            {includedFeatures.map((feature, index) => {
            const Icon = ICONS[index % ICONS.length];
            return <li key={feature} className="flex h-full flex-col items-center justify-start gap-5 rounded-xl border border-night-line/70 bg-night-soft/60 px-6 py-9 text-center" data-id="element-110" data-mp="ros23tcayij5" data-mpi={index}>
                  <span className="flex h-14 w-14 items-center justify-center rounded-full bg-gold" data-id="element-111" data-mp="3mgbu9m1zap3v">
                    <Icon className="h-6 w-6 text-night-deep" aria-hidden="true" data-id="element-112" data-mp="42kz9bflav7e" />
                  </span>
                  <span className="mt-auto text-sm leading-relaxed text-cream md:text-base" data-id="element-113" data-mp="3vf5t7j2s7rkl">{feature}</span>
                </li>;
          })}
          </ul>
        </div>
      </div>
    </section>;
}